<template>
  <div class='registration-page'>
    <div class='registration-page-container'>

      <div class='section'>
        <div class='section-header'>
          <h3>구매자 정보</h3>
        </div>
        <div class='section-body'>
          <dl class='field-group'>
            <dt class='field-label'>
              <label for=''>구매대리점</label>
            </dt>
            <dd class='field-control'>
              <input :value="`${$store.state.connectedCar.dealerInfo.agentName ? $store.state.connectedCar.dealerInfo.agentName :''}(${$store.state.connectedCar.dealerInfo.dealCd ? $store.state.connectedCar.dealerInfo.dealCd : ''})`" class='input-text input-font input-text-disabled input-width-large' readonly title='구매대리점명'>
            </dd>
          </dl>
          <dl class='field-group'>
            <dt class='field-label'>
              <label for='' >구매쇼핑몰</label>
            </dt>
            <dd class='field-control'>
              <input :value="`${$store.state.connectedCar.dealerInfo.openMarketName}`" class='input-text input-font input-text-disabled input-width-large' readonly title='구매쇼핑몰명'>
            </dd>
          </dl>          
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'ConnectedCarBasicInformationSection',

    props: {},

    data() {
      return {
        retrieveData: {
          dealCd: ''
          
        }
      }
    },

    computed: {},

    methods: {},
  }
</script>

<style scoped>
</style>
